<template>
<div>
  <div>
    <SelectCdjProjectHeader ref="SelectCdjProjectHeader" @onHeader="onHeader">
      <el-button size="mini" type="primary" @click="getExcel">导出数据</el-button>
    </SelectCdjProjectHeader>
  </div>
  <div>
    <el-descriptions :column="3" border size="mini">
      <el-descriptions-item label="房产">
        <el-input v-model="where.house_name" placeholder="请输入房产" clearable size="mini" @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="客户名称">
        <el-input v-model="where.customer_name" placeholder="请输入客户名称" clearable size="mini" @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="业户房产关系">
        <el-select v-model="where.customer_house_status" multiple placeholder="请选择业户房产关系" clearable size="mini" @change="pageChange(1)">
          <el-option label="业主/租户" value="1"></el-option>
          <el-option label="业主/历史租户" value="2"></el-option>
          <el-option label="业主" value="3"></el-option>
          <el-option label="历史业主/租户" value="4"></el-option>
          <el-option label="历史业主/历史租户" value="5"></el-option>
          <el-option label="历史业主" value="6"></el-option>
          <el-option label="租户" value="7"></el-option>
          <el-option label="历史租户" value="8"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="房产类型">
        <el-select v-model="where.house_type" multiple placeholder="请选择房产类型" clearable size="mini" @change="pageChange(1)">
          <el-option label="住宅" value="1"></el-option>
          <el-option label="车位" value="2"></el-option>
          <el-option label="储藏室" value="3"></el-option>
          <el-option label="商铺" value="4"></el-option>
          <el-option label="写字楼" value="5"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="房态">
        <el-select v-model="where.house_status" multiple placeholder="请选择房态" clearable size="mini" @change="pageChange(1)">
          <el-option label="空置" value="1"></el-option>
          <el-option label="未领" value="2"></el-option>
          <el-option label="空关" value="3"></el-option>
          <el-option label="装修" value="4"></el-option>
          <el-option label="入住" value="5"></el-option>
          <el-option label="出租" value="6"></el-option>
          <el-option label="停用" value="7"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="客户类型">
        <el-select v-model="where.customer_type" multiple placeholder="请选择客户类型" clearable size="mini" @change="pageChange(1)">
          <el-option label="业主" value="1"></el-option>
          <el-option label="租户" value="2"></el-option>
          <el-option label="住户" value="3"></el-option>
          <el-option label="共有人" value="4"></el-option>
          <el-option label="开发商" value="5"></el-option>
          <el-option label="其它" value="9"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="客户性质">
        <el-select v-model="where.customer_class" multiple placeholder="请选择客户性质" clearable size="mini" @change="pageChange(1)">
          <el-option label="个人客户" value="1"></el-option>
          <el-option label="企业客户" value="2"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="客户分类">
        <el-select v-model="where.customer_category" multiple placeholder="请选择客户分类" clearable size="mini" @change="pageChange(1)">
          <el-option label="非常重要业主★★★★★" value="1"></el-option>
          <el-option label="重要客户★★★★" value="2"></el-option>
          <el-option label="一般业主★★★" value="3"></el-option>
          <el-option label="问题客户★★" value="4"></el-option>
          <el-option label="反对客户★" value="5"></el-option>
          <el-option label="其他" value="6"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="性别">
        <el-select v-model="where.customer_sex" multiple placeholder="请选择性别" clearable size="mini" @change="pageChange(1)">
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="特殊身份">
        <el-select v-model="where.customer_special" multiple placeholder="请选择特殊身份" clearable size="mini" @change="pageChange(1)">
          <el-option label="地市级政府官员" value="1"></el-option>
          <el-option label="物业管理行业主管领导" value="2"></el-option>
          <el-option label="大型公司/地产公司董事长" value="3"></el-option>
          <el-option label="大型公司/地产公司总裁" value="4"></el-option>
          <el-option label="大型公司/地产公司总经理" value="5"></el-option>
          <el-option label="知名媒体人士" value="6"></el-option>
          <el-option label="影视明星" value="7"></el-option>
          <el-option label="业委会主任/副主任" value="8"></el-option>
          <el-option label="社区主任" value="9"></el-option>
          <el-option label="物业管理行业领导" value="10"></el-option>
          <el-option label="派出所领导" value="11"></el-option>
          <el-option label="一般公司董事长" value="12"></el-option>
          <el-option label="一般公司总裁" value="13"></el-option>
          <el-option label="一般公司总经理" value="14"></el-option>
          <el-option label="地产公司物业对接人" value="15"></el-option>
          <el-option label="业委会成员" value="16"></el-option>
          <el-option label="热心业户" value="17"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="房产唯一">
        <el-select v-model="where.house_unique" placeholder="请选择房产唯一" clearable size="mini" @change="pageChange(1)">
          <el-option label="唯一" :value="1"></el-option>
          <el-option label="非唯一" :value="2"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="客户唯一">
        <el-select v-model="where.customer_unique" placeholder="请选择客户唯一" clearable size="mini" @change="pageChange(1)">
          <el-option label="唯一" :value="1"></el-option>
          <el-option label="非唯一" :value="2"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <HeaderTip>
      数量：{{pageData.total}}
    </HeaderTip>
  </div>
  <div>
    <el-table v-loading="is_loading" border height="calc(100vh - 490px)" :data="pageData.data" style="width: 100%">
      <el-table-column prop="project_name" label="项目" width="150" fixed></el-table-column>
      <el-table-column prop="house_name" label="房产" min-width="320" align="center" fixed></el-table-column>
      <el-table-column label="房产信息" align="center">
        <el-table-column prop="house_type" label="房产类型" align="center" width="80"></el-table-column>
        <el-table-column prop="room_status_text" label="房态" align="center" width="80"></el-table-column>
        <el-table-column prop="floor_name" label="楼层" align="center" width="80"></el-table-column>
        <el-table-column prop="house_area" label="建筑面积" align="center" width="100"></el-table-column>
        <el-table-column prop="house_dwelling_space" label="套内面积" align="center" width="100"></el-table-column>
        <el-table-column prop="house_charging" label="计费面积" align="center" width="100"></el-table-column>
        <el-table-column prop="house_garden" label="花园面积" align="center" width="100"></el-table-column>
        <el-table-column prop="house_share" label="分摊面积" align="center" width="100"></el-table-column>
      </el-table-column>
      <el-table-column prop="customer_house_status_text" label="业户房产关系" align="center" width="100"></el-table-column>
      <el-table-column label="客户信息" align="center">
        <el-table-column prop="customer_id" label="客户ID" align="center" width="80"></el-table-column>
        <el-table-column prop="customer_name" label="客户名称" align="center" width="150"></el-table-column>
        <el-table-column prop="customer_project_name" label="所属组织" align="center" width="150"></el-table-column>
        <el-table-column prop="customer_class_text" label="客户性质" align="center" width="90"></el-table-column>
        <el-table-column prop="customer_type_text" label="客户类型" align="center" width="80"></el-table-column>
        <el-table-column prop="customer_type_text" label="客户分类" align="center" width="80"></el-table-column>
        <el-table-column prop="customer_sex_text" label="性别" align="center" width="60"></el-table-column>
        <el-table-column prop="nation" label="民族" align="center" width="100"></el-table-column>
        <el-table-column prop="credentials_code" label="证件编号" align="center" width="180"></el-table-column>
        <el-table-column prop="birthday" label="出生年月" align="center" width="120"></el-table-column>
        <el-table-column prop="native_place" label="籍贯" align="center" width="200"></el-table-column>
        <el-table-column prop="registered_residence" label="户籍" align="center" width="200"></el-table-column>
        <el-table-column prop="home_address" label="家庭地址" align="center" width="250"></el-table-column>
        <el-table-column prop="post_address" label="邮寄地址" align="center" width="250"></el-table-column>
        <el-table-column prop="contact_number" label="联系电话" align="center" width="200"></el-table-column>
        <el-table-column prop="t_contact_name" label="紧急联系人" align="center" width="100"></el-table-column>
        <el-table-column prop="t_contact_name" label="紧急联系人电话" align="center" width="150"></el-table-column>
        <el-table-column prop="t_contact_name" label="工作单位" align="center" width="200"></el-table-column>
        <el-table-column prop="company_address" label="工作单位地址" align="center" width="250"></el-table-column>
        <el-table-column prop="customer_special_text" label="特殊身份" align="center" width="200"></el-table-column>
        <el-table-column prop="bank_name" label="开户行" align="center" width="100"></el-table-column>
        <el-table-column prop="bank_account" label="开户帐号" align="center" width="180"></el-table-column>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination
      @current-change="pageChange"
      :current-page="pageData.current_page"
      :page-size="pageData.per_page"
      layout="total, prev, pager, next"
      :total="pageData.total">
    </el-pagination>
  </div>
</div>
</template>

<script>
import SelectCdjProjectHeader from "../../../Butler/components/common/SelectCdjProjectHeader";
import CustomerHttp from "../../common/CustomerHttp";
import {CommonHelp} from "../../../Butler/common/CommonHelp";
import HeaderTip from "../../../Common/header-tip";
export default {
  name: "HouseCustomerList",
  components: {HeaderTip, SelectCdjProjectHeader},
  data(){
    return{
      where:{
        house_name:"",
        house_type:[],
        house_status:[],
        customer_house_status:[],
        customer_name:"",
        customer_type:[],
        customer_class:[],
        customer_category:[],
        customer_sex:[],
        customer_special:[],
        house_unique:2,
        customer_unique:2,
      },
      is_loading:false,
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[]
      },
      pageData: {
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
    }
  },
  mounted() {
    const that=this;
    that.$refs.SelectCdjProjectHeader.getAllTree(()=>{
      that.$refs.SelectCdjProjectHeader.initLegalSearchObj()
    });
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        house_name:that.where.house_name,
        house_type:that.where.house_type.join(","),
        house_status:that.where.house_status.join(","),
        customer_house_status:that.where.customer_house_status.join(","),
        customer_name:that.where.customer_name,
        customer_type:that.where.customer_type.join(","),
        customer_class:that.where.customer_class.join(","),
        customer_category:that.where.customer_category.join(","),
        customer_sex:that.where.customer_sex.join(","),
        customer_special:that.where.customer_special.join(","),
        house_unique:that.where.house_unique,
        customer_unique:that.where.customer_unique
      }
      CustomerHttp.post("/customer/HouseCustomer/getHouseCustomerList?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page, {
        ...where
      }, res => {
        console.log(res)
        if (res.code) {
          that.pageData = res.data;
        }
        that.is_loading = false;
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.current_page = i
      CommonHelp.debounce(function () {
        that.getList()
      },500,that)
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;

      console.log(data)

      that.pageChange(1)
    },
    getExcel() {
      const that = this;
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        house_name:that.where.house_name,
        house_type:that.where.house_type.join(","),
        house_status:that.where.house_status.join(","),
        customer_house_status:that.where.customer_house_status.join(","),
        customer_name:that.where.customer_name,
        customer_type:that.where.customer_type.join(","),
        customer_class:that.where.customer_class.join(","),
        customer_category:that.where.customer_category.join(","),
        customer_sex:that.where.customer_sex.join(","),
        customer_special:that.where.customer_special.join(","),
        house_unique:that.where.house_unique,
        customer_unique:that.where.customer_unique
      }
      CustomerHttp.post("/customer/HouseCustomer/getHouseCustomerExcel", {
        ...where
      }, res => {
        if (res.code) {
          window.open(res.data)
        }else {
          that.$message.error(res.msg)
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/list/HouseCustomerList.vue